import React from "react";
import { Flex, Text, Button } from "@appsmith/ads";
import { INTEGRATIONS_ICONS } from "../constants/integrationsIcons";

const IntegrationCard = (props: { iconSrc: string; name: string }) => {
  const { iconSrc, name } = props;

  return (
    <Flex
      alignItems="center"
      border="1px solid"
      borderColor="var(--ads-v2-color-bg-subtle)"
      borderRadius="8px"
      boxShadow="0px 1px 4px 0px rgba(76, 86, 100, 0.16)"
      height="64px"
      justifyContent="center"
      width="64px"
    >
      <img alt={name} src={iconSrc} width="32px" />
    </Flex>
  );
};

export const BlankState = (props: { onConnectClick: () => void }) => {
  const { onConnectClick } = props;

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      justifyContent="flex-start"
    >
      <Text kind="action-m" renderAs="p">
        Empower your agent with your favourite services.
      </Text>
      <Flex gap="spaces-4" marginBottom="spaces-7" marginTop="spaces-5">
        {Object.entries(INTEGRATIONS_ICONS).map(([name, iconSrc]) => (
          <IntegrationCard iconSrc={iconSrc} key={name} name={name} />
        ))}
      </Flex>
      <Button kind="primary" onClick={onConnectClick} size="md">
        Connect yours now
      </Button>
    </Flex>
  );
};
